module.exports = __webpack_public_path__ + "img/28.a7f0a858.png";